import _ from 'lodash'
import eventTypes from '../../../../../../../../../../theme/eventTypes'
import readingTypes from '../../../../../../../../../../theme/readingTypes'

export default _.uniqBy(
  _.concat(eventTypes, readingTypes), 'name'
)
